export default __webpack_public_path__ + "static/assets/86e84e84a42b6fb87e6b97b26f570412.svg";